import { render } from "./SitzungDetailsMittel.pug?vue&type=template&id=d8baa9fe&lang=pug"
import script from "./SitzungDetailsMittel.js?vue&type=script&lang=js"
export * from "./SitzungDetailsMittel.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__